import {imgPath} from './imgPath'
const CONFIG = {}
CONFIG.install = function(Vue,options){
    Vue.prototype.$imgPath=imgPath
}
export {CONFIG}


// WEBPACK FOOTER //
// ./src/config/index.js